export default "__VITE_ASSET__b52cd127__"